"use strict";

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.optimizeOptions = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = require("react");

var _axios = _interopRequireDefault(require("axios"));

var _stringSimilarity = require("string-similarity");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var optimizeOptions = function optimizeOptions() {
  var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return (0, _toConsumableArray2["default"])(options).filter(function (option) {
    var _option$centre, _option$centre$coordi; // A valid option must have a "nom" field and a geo-point


    return (option === null || option === void 0 ? void 0 : option.nom) && (option === null || option === void 0 ? void 0 : (_option$centre = option.centre) === null || _option$centre === void 0 ? void 0 : (_option$centre$coordi = _option$centre.coordinates) === null || _option$centre$coordi === void 0 ? void 0 : _option$centre$coordi.length) === 2;
  }).sort(function (a, b) {
    // sort by similarity
    return (0, _stringSimilarity.compareTwoStrings)(b.nom || '', search) - (0, _stringSimilarity.compareTwoStrings)(a.nom || '', search);
  }).slice(0, 30); // and only take 30
};

exports.optimizeOptions = optimizeOptions;

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'START_FETCHING':
      return _objectSpread({}, state, {
        loading: true
      });

    case 'CANCEL_FETCH':
      return _objectSpread({}, state, {
        loading: false,
        error: undefined
      });

    case 'FETCH_ERROR':
      return {
        error: action.error
      };

    case 'FETCH_SUCCESS':
      var options = optimizeOptions(action.search, action.options);
      return {
        options: options,
        loading: false
      };

    default:
      return state;
  }
};

var useRemoteOptions = function useRemoteOptions(search, open) {
  var minSearchLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  var notify = arguments.length > 3 ? arguments[3] : undefined;

  var _useReducer = (0, _react.useReducer)(reducer, {}),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  (0, _react.useEffect)(function () {
    if (!search) {
      return dispatch({
        type: 'FETCH_SUCCESS',
        options: []
      });
    }

    if (!open || search.length < minSearchLength) {
      return dispatch({
        type: 'CANCEL_FETCH'
      });
    }

    var cancelToken = _axios["default"].CancelToken.source();

    dispatch({
      type: 'START_FETCHING'
    });

    _axios["default"].get('https://geo.api.gouv.fr/communes', {
      params: {
        nom: search,
        fields: 'nom,codeDepartement,centre',
        format: 'json',
        geometry: 'centre',
        boost: true
      },
      cancelToken: cancelToken.token
    }).then(function (response) {
      return dispatch({
        search: search,
        type: 'FETCH_SUCCESS',
        options: response.data
      });
    })["catch"](function (e) {
      if (!_axios["default"].isCancel(e)) {
        /** Notify bugsnag about this error */
        notify === null || notify === void 0 ? void 0 : notify('Geosearch failed', {
          severity: 'info',
          metaData: {
            search: search
          }
        });
        dispatch({
          type: 'FETCH_ERROR',
          error: e
        });
      }
    });

    return function () {
      return cancelToken.cancel();
    };
  }, [minSearchLength, search, open]);
  return state;
};

__signature__(useRemoteOptions, "useReducer{[state, dispatch]({})}\nuseEffect{}");

var _default = useRemoteOptions;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(optimizeOptions, "optimizeOptions", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/useRemoteOptions.ts");
  reactHotLoader.register(reducer, "reducer", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/useRemoteOptions.ts");
  reactHotLoader.register(useRemoteOptions, "useRemoteOptions", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/useRemoteOptions.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/useRemoteOptions.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();